import { useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { useAuth } from '@/lib/auth';
import { toast } from 'sonner';

export default function AuthCallbackPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { setUserFromGoogle } = useAuth();

  useEffect(() => {
    const token = searchParams.get('token');
    const name = searchParams.get('name');
    const email = searchParams.get('email');
    const id = searchParams.get('id');

    if (token && email && id) {
      setUserFromGoogle(token, { id, name: name || '', email });
      toast.success('Signed in with Google');
      navigate('/dashboard', { replace: true });
    } else {
      toast.error('Google sign-in failed');
      navigate('/login', { replace: true });
    }
  }, [searchParams, navigate, setUserFromGoogle]);

  return (
    <div className="min-h-screen bg-[#09090b] flex items-center justify-center">
      <div className="h-8 w-8 border-2 border-sky-500 border-t-transparent rounded-full animate-spin" />
    </div>
  );
}
